/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTumorBoards } from 'app/entities/tumor-board/tumor-board.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { TumorBoardPatientStatus } from 'app/shared/model/enumerations/tumor-board-patient-status.model';
import { createEntity, getEntity, reset, updateEntity } from './tumor-board-patient.reducer';

export const TumorBoardPatientUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const tumorBoards = useAppSelector(state => state.tumorBoard.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const tumorBoardPatientEntity = useAppSelector(state => state.tumorBoardPatient.entity);
  const loading = useAppSelector(state => state.tumorBoardPatient.loading);
  const updating = useAppSelector(state => state.tumorBoardPatient.updating);
  const updateSuccess = useAppSelector(state => state.tumorBoardPatient.updateSuccess);
  const tumorBoardPatientStatusValues = Object.keys(TumorBoardPatientStatus);

  const handleClose = () => {
    navigate(`/tumor-board-patient${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTumorBoards({}));
    dispatch(getGlucoUsers({}));
    dispatch(getDoctors({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.addedAt !== undefined && typeof values.addedAt !== 'number') {
      values.addedAt = Number(values.addedAt);
    }
    if (values.completedAt !== undefined && typeof values.completedAt !== 'number') {
      values.completedAt = Number(values.completedAt);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tumorBoardPatientEntity,
      ...values,
      board: tumorBoards.find(it => it.id.toString() === values.board?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      addedBy: doctors.find(it => it.id.toString() === values.addedBy?.toString()),
      handedOverBy: doctors.find(it => it.id.toString() === values.handedOverBy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          status: 'PENDING',
          ...tumorBoardPatientEntity,
          board: tumorBoardPatientEntity?.board?.id,
          patient: tumorBoardPatientEntity?.patient?.id,
          addedBy: tumorBoardPatientEntity?.addedBy?.id,
          handedOverBy: tumorBoardPatientEntity?.handedOverBy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.tumorBoardPatient.home.createOrEditLabel" data-cy="TumorBoardPatientCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.home.createOrEditLabel">Create or edit a TumorBoardPatient</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tumor-board-patient-id"
                  label={translate('tinyMedicRestApp.tumorBoardPatient.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardPatient.addedAt')}
                id="tumor-board-patient-addedAt"
                name="addedAt"
                data-cy="addedAt"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="addedAtLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.help.addedAt" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardPatient.completedAt')}
                id="tumor-board-patient-completedAt"
                name="completedAt"
                data-cy="completedAt"
                type="text"
              />
              <UncontrolledTooltip target="completedAtLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.help.completedAt" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardPatient.status')}
                id="tumor-board-patient-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {tumorBoardPatientStatusValues.map(tumorBoardPatientStatus => (
                  <option value={tumorBoardPatientStatus} key={tumorBoardPatientStatus}>
                    {translate(`tinyMedicRestApp.TumorBoardPatientStatus.${tumorBoardPatientStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="statusLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.help.status" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardPatient.active')}
                id="tumor-board-patient-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardPatient.cursor')}
                id="tumor-board-patient-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardPatient.lastUpdated')}
                id="tumor-board-patient-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardPatient.microSec')}
                id="tumor-board-patient-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardPatient.timestampEntry')}
                id="tumor-board-patient-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardPatient.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                id="tumor-board-patient-board"
                name="board"
                data-cy="board"
                label={translate('tinyMedicRestApp.tumorBoardPatient.board')}
                type="select"
              >
                <option value="" key="0" />
                {tumorBoards
                  ? tumorBoards.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-board-patient-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.tumorBoardPatient.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-board-patient-addedBy"
                name="addedBy"
                data-cy="addedBy"
                label={translate('tinyMedicRestApp.tumorBoardPatient.addedBy')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-board-patient-handedOverBy"
                name="handedOverBy"
                data-cy="handedOverBy"
                label={translate('tinyMedicRestApp.tumorBoardPatient.handedOverBy')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/tumor-board-patient" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TumorBoardPatientUpdate;
